// extracted by mini-css-extract-plugin
export default {"welcomeContainer":"Welcome_welcomeContainer__3w-kj","sectionHead":"Welcome_sectionHead__-Aa1q"};